import React from "react";
import history from "../data/history.json";
import styles from "../styles/timeline.module.css";

function Timeline() {
  return (
    <section className={styles.timeline} id="timeline">
      <h2>History of Scouting</h2>
      <div className={styles.timelineContainer}>
        {history.map((event, index) => (
          <div
            className={`${styles.timelineItem} ${index % 2 === 0 ? styles.left : styles.right}`}
            key={event.date}
          >
            <div className={styles.content}>
              <h3>{event.date}</h3>
              <h4>{event.title}</h4>
              <img 
                src={event.image.replace("%PUBLIC_URL%", process.env.PUBLIC_URL)} 
                alt={event.title} 
              />
              <p>{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Timeline;